<div [formGroup]="form">
    <div class="section-container" id="ficha-tecnica">
        <div class="section-title">
            <mat-icon>assignment</mat-icon>
            <span>Ficha Técnica (Atributos)</span>
        </div>

        <div formArrayName="atributos">
            <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
                <h4 class="subsection-title mb-0">Atributos</h4>
                <button type="button" mat-button (click)="addAtributoRow()">
                    <mat-icon>add</mat-icon> Adicionar
                </button>
            </div>

            @for (item of atributos.controls; track item; let i = $index) {
            <div [formGroupName]="i" class="row-wrapper">
                <div class="row w-100 g-2 align-items-center m-0">
                    <div class="col-5 col-lg-5">
                        @if(listaAtributo){
                        <app-select-pesquisavel label="Atributo" [offlineList]="listaAtributo"
                            [control]="getControl(item, 'idAtributo')" idField='id' nameField='descricao'>
                        </app-select-pesquisavel>
                        }
                    </div>
                    <div class="col-5 col-lg-5">
                        <mat-form-field appearance="outline">
                            <mat-label>Valor</mat-label>
                            <input matInput formControlName="valor">
                        </mat-form-field>
                    </div>
                    <div class="col-2 col-lg-2 delete-col produto-grid-delete-col">
                        <button type="button" mat-icon-button class="produto-grid-delete-button" (click)="removeAtributoRow(i)" matTooltip="Remover">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            }

            @if (atributos.length === 0) {
            <app-empty-state icon="assignment" title="Nenhum atributo cadastrado."
              subtitle="Adicione atributos para descrever as características técnicas deste produto.">
            </app-empty-state>
            }
        </div>
    </div>
</div>
